import { faUserEdit } from "@fortawesome/free-solid-svg-icons";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import { reduce } from "et3-type-guards";
import { SUPERVISOR_RECEIPT_DEFAULT_CONFIGURATION } from "../../../../constants/input-entries-constants";
import { getSupervisorReceiptConfigurationStore } from "../../../../stores/supervisor-store/supervisor-receipt-configuration-store";
import { TReceiptsConfigurationKeys } from "../../../../Types";

const ReceiptsConfigurationInputs = withLiteObserverAndTheme<{
  labelPrice: string;
  labelThreshold: string;
  labelDiscount: string;
  keyPrice: TReceiptsConfigurationKeys;
  keyThreshold: TReceiptsConfigurationKeys;
  keyDiscount: TReceiptsConfigurationKeys;
}>((props) => {
  const {
    theme,
    labelPrice,
    labelThreshold,
    labelDiscount,
    keyPrice,
    keyThreshold,
    keyDiscount
  } = props;
  const { colors } = theme;
  const supervisorEditDataMap = reduce(
    () =>
      getSupervisorReceiptConfigurationStore().receiptsConfigurationMappedObject.get(
        "RECEIPT_CONFIGURATION_DASHBOARD"
      ),
    SUPERVISOR_RECEIPT_DEFAULT_CONFIGURATION
  );

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="space-between"
      alignItems="center"
      withShadow={false}
      width={1200}
      height={100}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        type={"text"}
        icon={faUserEdit}
        label={labelThreshold}
        placeHolder={labelThreshold}
        value={supervisorEditDataMap[keyThreshold]}
        onChoose={(value: string) => {
          getSupervisorReceiptConfigurationStore().setReceiptsConfigurationObjectKey(
            keyThreshold,
            value
          );
        }}
        onBlur={() => {}}
        onEnter={() => {}}
        style={{}}
      />
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        type={"text"}
        icon={faUserEdit}
        label={labelDiscount}
        placeHolder={labelDiscount}
        value={supervisorEditDataMap[keyDiscount]}
        onChoose={(value: string) => {
          getSupervisorReceiptConfigurationStore().setReceiptsConfigurationObjectKey(
            keyDiscount,
            value
          );
        }}
        onBlur={() => {}}
        onEnter={() => {}}
        style={{}}
      />
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        type={"text"}
        icon={faUserEdit}
        label={labelPrice}
        placeHolder={labelPrice}
        value={supervisorEditDataMap[keyPrice]}
        onChoose={(value: string) => {
          getSupervisorReceiptConfigurationStore().setReceiptsConfigurationObjectKey(
            keyPrice,
            value
          );
        }}
        onBlur={() => {}}
        onEnter={() => {}}
        style={{}}
      />
    </ET3Div>
  );
});
export default ReceiptsConfigurationInputs;
